export const initialState = {
  exercises: [],
  educationMaterials: [],
  questionnaires: []
};
